// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const spamClientDescription = objectOf({
  client: string,
  type: string,
  description: string,
});

export const isEngagementGetSpamClientDescriptionsResult = arrayOf(spamClientDescription);
